<template>
  <div id="admin-index">
    <!-- 后台首页 -->
    <div class="top">
      <div class="left">
        <img src="@/assets/img/logo.png" alt="" object-fit="scale-down" />
      </div>
      <div class="perch-active"></div>
      <div class="menus">
        <div
          :class="{ menu: true, 'active-menu': active == menu.path }"
          v-for="(menu, index) in menu"
          :key="index"
          @click="goto(menu)"
        >
          {{ menu.text }}
          <div class="li"></div>
        </div>
      </div>
      <div class="icon">
        <el-dropdown>
          <div class="tx">
            <img :src="userData.icon" alt="" sizes="" srcset="" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><span @click="gotoSetting(0)">密码修改</span></el-dropdown-item
            >
            <el-dropdown-item
              ><span @click="gotoSetting(1)">退出</span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import * as base from "./js/base.js";
export default {
  data() {
    return {
      menu: base.getMenuList(),
      active: "index",
      userData: {},
    };
  },
  methods: {
    // 权限设置
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "0" },
        });
        console.log(resultData);
        this.menu = base.returnAllButton(this.menu, resultData, "text");
      } catch (error) {}
    },
    /**
     * 路由跳转
     */
    goto(menu) {
      sessionStorage.removeItem("subMenu");
      this.active = menu.path;
      sessionStorage.setItem("fatherMenu", this.active);
      if (menu.path != "index") {
        let subMenu = base.getSubMenuListByFatherMenu(menu.path)[0].path;
        sessionStorage.setItem("subMenu", subMenu);
      }
      this.$router.push("/admin/" + menu.path);
    },
    /**
     * 头像中的点击事件
     */
    async gotoSetting(flag) {
      switch (flag) {
        case 0:
          // 跳转值个人中心
          this.$router.push("/admin/personal-index");
          break;
        case 1:
          // 退出
          try {
            // let data = await this.$request({
            //   url: "/user/logout",
            //   method: "post",
            //   data: { userId: "" },
            // });
            sessionStorage.clear();
            this.$router.push("/admin");
          } catch (error) {
            this.$message.error(error.message);
          }
          break;

        default:
          break;
      }
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    this.active = sessionStorage.getItem("fatherMenu");
    this.userData = JSON.parse(sessionStorage.getItem("userData"));
  },
};
</script>

<style lang="less" scoped>
#admin-index {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 1000px;
  > .top {
    width: 100%;
    height: 90px;
    background-color: @baseColor;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    > .left {
      width: 280px;
      height: 100%;
      display: flex;
      // background-color: rgba(255, 255, 255, 0.363);
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      img {
        width: 100%;
      }
    }
    > .menus {
      width: auto;
      height: 100%;
      display: flex;
      margin-right: 20px;
      > .menu {
        width: auto;
        height: 100%;
        padding: 0 30px;
        display: flex;
        align-items: flex-end;
        color: #fff;
        padding-bottom: 15px;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
        transition: 0.3s;
        font-weight: bold;
        &:hover {
          background-color: #fff;
          color: @baseColor;
        }
      }
      > .active-menu {
        background-color: #fff;
        color: @baseColor;
        position: relative;
        > .li {
          width: 60%;
          height: 3px;
          background-color: @baseColor;
          position: absolute;
          bottom: 5px;
          left: 20%;
        }
      }
    }
    > .icon {
      width: 90px;
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      .tx {
        width: 65px;
        height: 65px;
        // background-color: #fff;
        > img {
          width: 100%;
          height: 100%;
          border-radius: 35px;
        }
      }
    }
  }
  > .content {
    width: 100%;
    height: 0;
    flex: 1;
    background-color: #ececec;
  }
}
</style>